import { Transition } from "@headlessui/react";
import React from "react";

const FadeIn: React.FC<React.PropsWithChildren<{ show: boolean }>> = ({ show, ...props }) => {
  return (
    <Transition.Root show={show}>
      <Transition
        appear={true}
        enter="transform ease-out duration-300 transition"
        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 "
        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        {(ref) => (
          <div ref={ref} className="w-full">
            {props.children}
          </div>
        )}
      </Transition>
    </Transition.Root>
  );
};

export default FadeIn;
